import React, { useEffect, useState } from "react";
import { getUserData, getUserHistory } from "../../controllers/userController";
import logo from "../../assets/icons/logo-banco-da-felicidade.svg";
import coin1 from "../../assets/icons/moeda-1.svg";
import coin5 from "../../assets/icons/moeda-5.svg";
import coin10 from "../../assets/icons/moeda-10.svg";
import coin50 from "../../assets/icons/moeda-50.svg";
import coin100 from "../../assets/icons/moeda-100.svg";
import { Link } from "react-router-dom";
import giftIcon from "../../assets/icons/icon-gift.svg";
import { formatDate, formatTime, sumMoedas } from "../../utils";
import { Container, ContentSection, Content } from "../../styles/styles";
import iconPrizes from "../../assets/icons/icon-prizes.svg";
import iconHistory from "../../assets/icons/icon-history.svg";
import iconRanking from "../../assets/icons/icon-ranking.svg";
import iconGive from "../../assets/icons/icon-give.svg";
import iconRemove from "../../assets/icons/icon-remove.svg";
import Footer from "../../components/footer";
import GlobalStyle from "../../styles/global";
import { Header, HistoricoSection, HomeContent, styles } from "./styles";
import { FaRegBell } from "react-icons/fa";
import { FaCircleUser } from "react-icons/fa6";

function Home() {
  const [userData, setUserData] = useState({});
  const [moedasDistribuidas, setMoedasDistribuidas] = useState({});
  const [activeTab, setActiveTab] = useState('historico');
  const [moedasType, setMoedasType] = useState('Moedas Minha Equipe');
  const [history, setHistory] = useState([]);

  const user = JSON.parse(localStorage.getItem("user")) || {};

  useEffect(() => {
    const fetchData = async () => {
      if (user?.idusuario) {
        try {
          const userInfo = await getUserData(user.idusuario);
          setUserData(userInfo);

          if (userInfo && userInfo.moedas_a_distribuir) {
            setMoedasDistribuidas(JSON.parse(userInfo.moedas_a_distribuir));
          } else {
            setMoedasDistribuidas({});
          }

          const userHistory = await getUserHistory(user.idusuario);
          setHistory(userHistory);
          
        } catch (error) {
          console.error("Falha ao buscar dados da página Home:", error);
          setMoedasDistribuidas({});
        }
      }
    };

    fetchData();
  }, [user?.idusuario]);

  // Função para renderizar os ícones das moedas
  const renderMoedasComIcones = (amount) => {
    let moedas;
    if (typeof amount === 'string') {
      try {
        moedas = JSON.parse(amount);
      } catch {
        moedas = {};
      }
    } else {
      moedas = amount || {};
    }

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginTop: '4px' }}>
        {moedas["1"] > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <img src={coin1} alt="1 Moeda" style={{ width: '20px', height: '20px' }} />
            <span style={{ fontSize: '11px', color: '#666' }}>{moedas["1"]}</span>
          </div>
        )}
        {moedas["5"] > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <img src={coin5} alt="5 Moedas" style={{ width: '20px', height: '20px' }} />
            <span style={{ fontSize: '11px', color: '#666' }}>{moedas["5"]}</span>
          </div>
        )}
        {moedas["10"] > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <img src={coin10} alt="10 Moedas" style={{ width: '20px', height: '20px' }} />
            <span style={{ fontSize: '11px', color: '#666' }}>{moedas["10"]}</span>
          </div>
        )}
        {moedas["50"] > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <img src={coin50} alt="50 Moedas" style={{ width: '20px', height: '20px' }} />
            <span style={{ fontSize: '11px', color: '#666' }}>{moedas["50"]}</span>
          </div>
        )}
        {moedas["100"] > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <img src={coin100} alt="100 Moedas" style={{ width: '20px', height: '20px' }} />
            <span style={{ fontSize: '11px', color: '#666' }}>{moedas["100"]}</span>
          </div>
        )}
      </div>
    );
  };

  const carteiraSelecionada = moedasDistribuidas[moedasType] || {};

  const historicoPersonal = history?.filter(item =>
    (item.type === "credito" || item.type === "resgate" || item.type === "remocao") &&
    item.nome !== null && item.amount !== null && item.date !== null
  ) || [];


  const moedasDistribuidasData = history?.filter(item =>
    item.type === "credito_enviado" &&
    item.nome !== null &&
    item.amount !== null &&
    item.date !== null
  ) || [];

  const moedasTypeStyles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '20px',
      marginTop: '20px',
      padding: '0 20px'
    },
    tabContainer: {
      display: 'flex',
      backgroundColor: '#f0f0f0',
      borderRadius: '25px',
      padding: '4px',
      width: '100%',
      maxWidth: '500px',
      border: '1px solid #e0e0e0'
    },
    tabButton: {
      padding: '12px 20px', 
      border: 'none',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      borderRadius: '21px',
      transition: 'all 0.3s ease',
      flex: '1',
      textAlign: 'center',
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      lineHeight: '1.2' 
    },
    activeTab: {
      backgroundColor: '#4CAF50',
      color: 'white',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    inactiveTab: {
      backgroundColor: 'transparent',
      color: '#666'
    }
  };

  return (
    <>
      <GlobalStyle />
      <Header>
        <div className="headerButtons">
          <img src={logo} alt="Logo Banco da Felicidade" className="logo" />
          <button>
            <FaRegBell />
          </button>
        </div>
        <div className="info">
          <FaCircleUser />
          <div className="userInfo">
            <h1 className="headerText">Bem-vindo de volta!</h1>
            <h2 className="userName">{userData.nome}</h2>
            <p className="userDetails">{userData.unidade}</p>
            <p className="userDetails">{userData.cargo}</p>
          </div>
          <div className="saldo">
            <h3 className="saldoTitle">Meu saldo</h3>
            <h2 className="saldoValue">{userData.saldo_moedas}</h2>
          </div>
        </div>
      </Header>

      {(userData.cargo === "Gestor" || user.nivel === 1) && (
        <div style={moedasTypeStyles.container}>
          <div style={moedasTypeStyles.tabContainer}>
            <button
              style={{
                ...moedasTypeStyles.tabButton,
                ...(moedasType === 'Moedas Minha Equipe' ? moedasTypeStyles.activeTab : moedasTypeStyles.inactiveTab)
              }}
              onClick={() => setMoedasType('Moedas Minha Equipe')}
            >
              Moedas Minha Equipe
            </button>
            <button
              style={{
                ...moedasTypeStyles.tabButton,
                ...(moedasType === 'Moedas Outras Unidades' ? moedasTypeStyles.activeTab : moedasTypeStyles.inactiveTab)
              }}
              onClick={() => setMoedasType('Moedas Outras Unidades')}
            >
              Moedas Outras Unidades
            </button>
          </div>
        </div>
      )}

      <div style={styles.moedasSection}>
        {user.nivel !== 0 && (
          <>
            {user.nivel === 1 ? (
              <p style={styles.sectionTitle}>Moedas para distribuir:</p>
            ) : (
              <p style={styles.sectionTitle}>Moedas para emocionar:</p>
            )}
            <div style={styles.moedasContainer}>
              {user.nivel === 1 ? (
                <p style={{ color: "black", width: '100%', textAlign: 'center' }}>Ilimitado</p>
              ) : (
                <>
                  <div style={styles.moedaItem}>
                    <img src={coin1} alt="1 Moeda" style={styles.moedaIcon} />
                    <p style={styles.moedaText}>
                      {carteiraSelecionada["1"] || 0}
                    </p>
                  </div>
                  <div style={styles.moedaItem}>
                    <img src={coin5} alt="5 Moedas" style={styles.moedaIcon} />
                    <p style={styles.moedaText}>
                      {carteiraSelecionada["5"] || 0}
                    </p>
                  </div>
                  <div style={styles.moedaItem}>
                    <img src={coin10} alt="10 Moedas" style={styles.moedaIcon} />
                    <p style={styles.moedaText}>
                      {carteiraSelecionada["10"] || 0}
                    </p>
                  </div>
                  <div style={styles.moedaItem}>
                    <img src={coin50} alt="50 Moedas" style={styles.moedaIcon} />
                    <p style={styles.moedaText}>
                      {carteiraSelecionada["50"] || 0}
                    </p>
                  </div>
                  <div style={styles.moedaItem}>
                    <img src={coin100} alt="100 Moedas" style={styles.moedaIcon} />
                    <p style={styles.moedaText}>
                      {carteiraSelecionada["100"] || 0}
                    </p>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>

      <HomeContent>
        {user.nivel !== 0 ? (
          <>
            <Link to="/emocionar" className="emocionarSection">
              <button className="emocionarButton">Emocionar</button>
            </Link>
          </>
        ) : null}

        <Container
          justify="center"
          align="center"
          direction="row"
          style={{ gap: "20px" }}
        >
          {user.nivel === 1 ? (
            <>
              <Link to="/dashboard">
                <img src={iconRanking} alt="Ranking" />
              </Link>
              <Link to="/remover-moedas">
                <img src={iconRemove} alt="Remove" />
              </Link>
              <Link to="/distribuir-moedas">
                <img src={iconGive} alt="Distribuir" />
              </Link>
            </>
          ) : null}
          <Link to="/premios">
            <img src={iconPrizes} alt="Prêmios" />
          </Link>
          <Link to="/">
            <img src={iconHistory} alt="Históricos" />
          </Link>
        </Container>

        <ContentSection fullWidth>
          <Content>
            {user.nivel !== 0 && (
              <>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', backgroundColor: '#f0f0f0', borderRadius: '30px', padding: '4px', width: '100%', maxWidth: '400px', border: '1px solid #e0e0e0' }}>
                    <button
                      style={{ padding: '12px 16px', border: 'none', backgroundColor: activeTab === 'historico' ? '#4CAF50' : 'transparent', color: activeTab === 'historico' ? 'white' : '#666', cursor: 'pointer', fontSize: '14px', fontWeight: activeTab === 'historico' ? '500' : '400', borderRadius: '26px', transition: 'all 0.3s ease', boxShadow: activeTab === 'historico' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none', flex: '1', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '120px', whiteSpace: 'nowrap' }}
                      onClick={() => setActiveTab('historico')}
                    >
                      Histórico pessoal
                    </button>
                    <button
                      style={{ padding: '12px 16px', border: 'none', backgroundColor: activeTab === 'envio' ? '#4CAF50' : 'transparent', color: activeTab === 'envio' ? 'white' : '#666', cursor: 'pointer', fontSize: '14px', fontWeight: activeTab === 'envio' ? '500' : '400', borderRadius: '26px', transition: 'all 0.3s ease', boxShadow: activeTab === 'envio' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none', flex: '1', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '120px', whiteSpace: 'nowrap' }}
                      onClick={() => setActiveTab('envio')}
                    >
                      Moedas distribuídas
                    </button>
                  </div>
                </div>
                <h3 style={styles.Title}>
                  {activeTab === 'historico' ? 'Histórico pessoal' : 'Moedas distribuídas'}
                </h3>
              </>
            )}

            {user.nivel === 0 && (
              <h3 style={styles.Title}>Histórico pessoal</h3>
            )}

            {(activeTab === 'historico' || user.nivel === 0) && (
              <HistoricoSection>
                {historicoPersonal.length > 0 ? (
                  historicoPersonal
                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                    .map((item, index) => {
                      const amount = item?.amount ?? 0;
                      const qtd = item?.qtd ?? 1;
                      const nome = item?.nome ?? "Nome não disponível";
                      const remetente = item?.distribuidor ?? null;
                      const remetenteUnidade = item?.distribuidorUnidade ?? null;
                      const date = item?.date ? formatTime(item.date) + " " + formatDate(item.date) : "Data indisponível";
                      const tipo_moeda = item?.tipo_moeda;
                      const soma = sumMoedas(amount);
                      console.log('Renderizando item de histórico:', { nome, tipo_moeda, remetente, remetenteUnidade, date, soma, amount, qtd, type: item.type });
                      
                      let iconSrc = logo;
                      let valorExibido = "";
                      let corTexto = "#000000";

                      if (item.type === "resgate") {
                        iconSrc = giftIcon;
                        valorExibido = `-${amount}`;
                      } else if (item.type === "remocao") {
                        iconSrc = logo;
                        valorExibido = `-${soma}`;
                      } else {
                        valorExibido = `+${soma}`;
                      }

                      return (
                        <div key={index} className="historicoItem">
                          <div className="itemType">
                            <img src={iconSrc} alt={item.type ?? "Tipo desconhecido"} className="imgIcon" />
                            <h5 className="historicoName">
                              {item.type === "remocao" ? (
                                <>
                                  {nome}
                                  <div className="remocaoDetails"><span style={{color: "#000000"}}>{item.receptor} ({item.receptorUnidade})</span></div>
                                  <div className="historicoDate"><p>{date}</p></div>
                                </>
                              ) : item.type === "resgate" ? (
                                <>
                                  {nome}
                                  <span>x {qtd}</span>
                                  <div className="historicoDate"><p>{date}</p></div>
                                </>
                              ) : (
                                <>
                                  {nome}
                                  {(item.type === "credito" || item.type === "remocao") && (
                                        <div style={{ marginTop: '4px', fontSize: '11px', fontWeight: '500', color: '#6c757d' }}>
                                            {remetente && (
                                                <div>
                                                    <span style={{color: '#D4AC0D'}}>De: {remetente} {remetenteUnidade && `(${remetenteUnidade})`}</span>
                                                </div>
                                            )}
                                            {tipo_moeda && (
                                                <div>
                                                    <span style={{ textTransform: 'capitalize', color: '#000000ff' }}>{'moeda ' + tipo_moeda}</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                  <div className="historicoDate"><p>{date}</p></div>
                                </>
                              )}
                            </h5>
                          </div>
                          <p className="historicoAmount" style={{ color: corTexto }}>{valorExibido}</p>
                        </div>
                      );
                    })
                ) : (
                  <p>Não há histórico disponível.</p>
                )}
              </HistoricoSection>
            )}

            {activeTab === 'envio' && user.nivel !== 0 && (
              <HistoricoSection>
                {moedasDistribuidasData.length > 0 ? (
                  moedasDistribuidasData
                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                    .map((item, index) => {
                      if (item.type !== "credito_enviado") return null;

                      const amount = item?.amount ?? 0;
                      const nome = item?.nome ?? "Nome não disponível";
                      const receptor = item?.receptor ?? "Destinatário não informado";
                      const tipo_moeda = item?.tipo_moeda;
                      const receptorUnidade = item?.receptorUnidade ?? "";
                      const date = item?.date ? formatTime(item.date) + " " + formatDate(item.date) : "Data indisponível";
                      const soma = sumMoedas(amount);
                      console.log('Renderizando moeda distribuída:', { receptor, receptorUnidade, nome, tipo_moeda, date, soma });

                      return (
                        <div key={index} className="historicoItem">
                          <div className="itemType">
                            <img src={logo} alt="Moeda distribuída" className="imgIcon" />
                            <h5 className="historicoName">
                              <div><b>{receptor}</b> {receptorUnidade && `(${receptorUnidade})`}</div>
                              <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>Motivo: {nome}</div>
                              {tipo_moeda && (
                                <div style={{ fontSize: '11px', color: '#000000ff', marginTop: '4px', textTransform: 'capitalize' }}>
                                   {tipo_moeda}
                                </div>
                              )}
                              <div className="historicoDate"><p>{date}</p></div>
                            </h5>
                          </div>
                          <p className="historicoAmount" style={{ color: "#4CAF50", fontWeight: 'bold' }}>+{soma}</p>
                        </div>
                      );
                    })
                ) : (
                  <p>Não há moedas distribuídas disponíveis.</p>
                )}
              </HistoricoSection>
            )}
          </Content>
        </ContentSection>
        <Footer />
      </HomeContent>
    </>
  );
}

export default Home;